import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { MoneyInput, PercentageInput } from '../../../components/Input/Input';
import { inputMoneyChange } from '../../../core/utils/string';
import { BUDGET_TABS } from '../utils/enum';
import { normalizeDecimalSeparator } from '../utils/functions';

export const TotalBudget = (props) => {
  const {
    totalParts,
    totalSum,
    totalBodyshopService,
    totalAeService,
    budget,
    values = {},
    onChange,
  } = props;

  const [bodyshopMoneyDiscount, setBodyshopMoneyDiscount] = useState(
    values.bodyshop_discount || 0
  );
  const [aestheticsMoneyDiscount, setAestheticsMoneyDiscount] = useState(
    values.aesthetics_discount || 0
  );
  const [partsMoneyDiscount, setPartsMoneyDiscount] = useState(
    values.parts_discount || 0
  );

  const [bodyshopPercentageDiscount, setBodyshopPercentageDiscount] = useState(
    values.bodyshop_percentage_discount || 0
  );
  const [aestheticsPercentageDiscount, setAestheticsPercentageDiscount] =
    useState(values.aesthetics_percentage_discount || 0);
  const [partsPercentageDiscount, setPartsPercentageDiscount] = useState(
    values.parts_percentage_discount || 0
  );

  useEffect(() => {
    setBodyshopMoneyDiscount(values.bodyshop_discount || 0);
    setAestheticsMoneyDiscount(values.aesthetics_discount || 0);
    setPartsMoneyDiscount(values.parts_discount || 0);

    setBodyshopPercentageDiscount(values.bodyshop_percentage_discount || 0);
    setAestheticsPercentageDiscount(values.aesthetics_percentage_discount || 0);
    setPartsPercentageDiscount(values.parts_percentage_discount || 0);
  }, [
    values.bodyshop_discount,
    values.aesthetics_discount,
    values.parts_discount,
    values.bodyshop_percentage_discount,
    values.aesthetics_percentage_discount,
    values.parts_percentage_discount,
  ]);

  const handleMoneyDiscountChange = (field, value) => {
    // Usa inputMoneyChange igual ao ColumnsServiceRenderer
    const processedValue = inputMoneyChange(value);

    // Extrai valor numérico para calcular porcentagem
    const numericValue =
      parseFloat(normalizeDecimalSeparator(processedValue)) || 0;

    if (field === 'bodyshop_discount') {
      setBodyshopMoneyDiscount(processedValue);
      // Sincroniza com porcentagem
      const total = parseFloat(totalBodyshopService) || 0;
      const percentage = total > 0 ? (numericValue / total) * 100 : 0;
      setBodyshopPercentageDiscount(parseFloat(percentage.toFixed(2)));
    } else if (field === 'aesthetics_discount') {
      setAestheticsMoneyDiscount(processedValue);
      // Sincroniza com porcentagem
      const total = parseFloat(totalAeService) || 0;
      const percentage = total > 0 ? (numericValue / total) * 100 : 0;
      setAestheticsPercentageDiscount(parseFloat(percentage.toFixed(2)));
    } else if (field === 'parts_discount') {
      setPartsMoneyDiscount(processedValue);
      // Sincroniza com porcentagem
      const total = parseFloat(totalParts) || 0;
      const percentage = total > 0 ? (numericValue / total) * 100 : 0;
      setPartsPercentageDiscount(parseFloat(percentage.toFixed(2)));
    }

    if (onChange) {
      onChange(field, processedValue);
      // Também chama onChange para o campo de porcentagem correspondente
      const percentageField = field.replace(
        '_discount',
        '_percentage_discount'
      );
      const total =
        field === 'bodyshop_discount'
          ? totalBodyshopService
          : field === 'aesthetics_discount'
          ? totalAeService
          : totalParts;
      const percentage =
        parseFloat(total) > 0 ? (numericValue / parseFloat(total)) * 100 : 0;
      onChange(percentageField, parseFloat(percentage.toFixed(2)));
    }
  };

  const handlePercentageDiscountChange = (field, value) => {
    const processedValue = inputMoneyChange(value);

    const numericValue =
      parseFloat(normalizeDecimalSeparator(processedValue)) || 0;

    if (field === 'bodyshop_percentage_discount') {
      setBodyshopPercentageDiscount(value);
      // Sincroniza com valor monetário
      const total = parseFloat(totalBodyshopService) || 0;
      const moneyValue = (total * numericValue) / 100;
      setBodyshopMoneyDiscount(moneyValue.toFixed(2));
    } else if (field === 'aesthetics_percentage_discount') {
      setAestheticsPercentageDiscount(value);
      // Sincroniza com valor monetário
      const total = parseFloat(totalAeService) || 0;
      const moneyValue = (total * numericValue) / 100;
      setAestheticsMoneyDiscount(moneyValue.toFixed(2));
    } else if (field === 'parts_percentage_discount') {
      setPartsPercentageDiscount(value);
      // Sincroniza com valor monetário
      const total = parseFloat(totalParts) || 0;
      const moneyValue = (total * numericValue) / 100;
      setPartsMoneyDiscount(moneyValue.toFixed(2));
    }

    if (onChange) {
      onChange(field, value);
      // Também chama onChange para o campo monetário correspondente
      const moneyField = field.replace('_percentage_discount', '_discount');
      const total =
        field === 'bodyshop_percentage_discount'
          ? totalBodyshopService
          : field === 'aesthetics_percentage_discount'
          ? totalAeService
          : totalParts;
      const moneyValue = (parseFloat(total) * numericValue) / 100;
      onChange(moneyField, moneyValue.toFixed(2));
    }
  };

  const calculateFinalValue = (total, moneyDiscount) => {
    const safeTotal = parseFloat(total) || 0;
    const safeMoneyDiscount =
      parseFloat(moneyDiscount?.toString()?.replace(',', '.')) || 0;

    const finalValue = safeTotal - safeMoneyDiscount;
    return Math.max(0, finalValue);
  };

  if (
    budget === BUDGET_TABS.DETAILS ||
    budget === BUDGET_TABS.NOTES ||
    budget === BUDGET_TABS.ENTRY_CHECKLIST ||
    budget === BUDGET_TABS.IMPORT_BUDGET
  ) {
    return;
  }

  return (
    <div className="values-box">
      {/* Linha dos totais */}
      <div className="totals-container">
        <div className="totals-row">
          <div className="total-section">
            <h4 className="values-title">
              Total funilaria:{' '}
              <span className="values-span">
                {(totalBodyshopService ?? 0).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </span>
            </h4>
          </div>
          <div className="total-section">
            <h4 className="values-title">
              Total serviços:{' '}
              <span className="values-span">
                {(totalAeService ?? 0).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </span>
            </h4>
          </div>
          <div className="total-section">
            <h4 className="values-title">
              Total peças:{' '}
              <span className="values-span">
                {(totalParts ?? 0).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </span>
            </h4>
          </div>
          <div className="total-section desktop-budget-total">
            <h4 className="values-title">
              Total orçamento:{' '}
              <span className="values-span">
                {(totalSum ?? 0).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </span>
            </h4>
          </div>
        </div>

        {/* Total orçamento separado para mobile */}
        <div className="mobile-budget-total">
          <div className="total-section">
            <h4 className="values-title">
              Total orçamento:{' '}
              <span className="values-span">
                {(totalSum ?? 0).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </span>
            </h4>
          </div>
        </div>
      </div>

      {/* Linha dos inputs de desconto */}
      <div className="discounts-row">
        <div className="discount-input-section">
          <PercentageInput
            placeholder="Desconto (%)"
            value={bodyshopPercentageDiscount}
            onChange={(value) =>
              handlePercentageDiscountChange(
                'bodyshop_percentage_discount',
                value
              )
            }
            className="discount-input"
            label={isMobile ? 'Desc.Funilaria' : ' Desconto Funilaria (%)'}
          />

          <MoneyInput
            type="number"
            placeholder="Desconto (R$)"
            value={bodyshopMoneyDiscount}
            onChange={(value) =>
              handleMoneyDiscountChange('bodyshop_discount', value)
            }
            className="discount-input"
            label={isMobile ? 'Desc.Funilaria' : 'Desconto Funilaria (%)'}
          />

          <div className="final-value">
            Final:{' '}
            {calculateFinalValue(
              totalBodyshopService,
              bodyshopMoneyDiscount
            ).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </div>
        </div>

        <div className="discount-input-section">
          <PercentageInput
            placeholder="Desconto (%)"
            value={aestheticsPercentageDiscount}
            onChange={(value) =>
              handlePercentageDiscountChange(
                'aesthetics_percentage_discount',
                value
              )
            }
            className="discount-input"
            label={isMobile ? 'Desc.Serviços' : 'Desconto Serviços (%)'}
          />

          <MoneyInput
            type="number"
            placeholder="Desconto (R$)"
            value={aestheticsMoneyDiscount}
            onChange={(value) =>
              handleMoneyDiscountChange('aesthetics_discount', value)
            }
            className="discount-input"
            label={isMobile ? 'Desc.Serviços' : 'Desconto Serviços (%)'}
          />

          <div className="final-value">
            Final:{' '}
            {calculateFinalValue(
              totalAeService,
              aestheticsMoneyDiscount
            ).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </div>
        </div>

        <div className="discount-input-section">
          <PercentageInput
            placeholder="Desconto (%)"
            value={partsPercentageDiscount}
            onChange={(value) =>
              handlePercentageDiscountChange('parts_percentage_discount', value)
            }
            className="discount-input"
            label={isMobile ? 'Desc.Peças' : 'Desconto Peças (%)'}
          />

          <MoneyInput
            type="number"
            placeholder="Desconto (R$)"
            value={partsMoneyDiscount}
            onChange={(value) =>
              handleMoneyDiscountChange('parts_discount', value)
            }
            className="discount-input"
            label={isMobile ? 'Desc.Peças' : 'Desconto Peças (%)'}
          />

          <div className="final-value">
            Final:{' '}
            {calculateFinalValue(totalParts, partsMoneyDiscount).toLocaleString(
              'pt-BR',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </div>
        </div>

        <div className="discount-input-section desktop-final-total">
          <div className="final-budget-total">
            Total Final:{' '}
            {(() => {
              const bodyshopFinal = calculateFinalValue(
                totalBodyshopService,
                bodyshopMoneyDiscount
              );
              const aestheticsFinal = calculateFinalValue(
                totalAeService,
                aestheticsMoneyDiscount
              );
              const partsFinal = calculateFinalValue(
                totalParts,
                partsMoneyDiscount
              );
              const finalTotal = bodyshopFinal + aestheticsFinal + partsFinal;
              return finalTotal.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              });
            })()}
          </div>
        </div>
      </div>

      {/* Total Final separado para mobile */}
      <div className="mobile-final-total">
        <div className="final-budget-total">
          Total Final:{' '}
          {(() => {
            const bodyshopFinal = calculateFinalValue(
              totalBodyshopService,
              bodyshopMoneyDiscount
            );
            const aestheticsFinal = calculateFinalValue(
              totalAeService,
              aestheticsMoneyDiscount
            );
            const partsFinal = calculateFinalValue(
              totalParts,
              partsMoneyDiscount
            );
            const finalTotal = bodyshopFinal + aestheticsFinal + partsFinal;
            return finalTotal.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            });
          })()}
        </div>
      </div>
    </div>
  );
};
